import { useEffect } from "react";
import { Clock, ArrowLeft, Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ComingSoonPageProps {
  title?: string;
  description?: string;
}

function ComingSoonPage({ 
  title = "Coming Soon", 
  description = "This page is currently under development. We're working hard to bring you amazing content." 
}: ComingSoonPageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-navy via-blue-900 to-brand-navy">
      <div className="container mx-auto px-5 sm:px-6 lg:px-4 py-20">
        <div className="max-w-3xl mx-auto text-center">
          {/* Icon */}
          <div className="flex justify-center mb-8">
            <div className="bg-white/10 p-8 rounded-full backdrop-blur-sm">
              <Clock className="w-20 h-20 sm:w-24 sm:h-24 text-gold animate-pulse" />
            </div>
          </div>

          {/* Title */}
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            {title}
          </h1>

          {/* Description */}
          <p className="font-body text-lg sm:text-xl text-white/90 leading-relaxed mb-8 max-w-2xl mx-auto">
            {description}
          </p>

          {/* Additional Info */}
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 sm:p-8 mb-10 border border-white/20">
            <p className="text-white/80 text-base sm:text-lg mb-4">
              Stay tuned for updates! In the meantime, feel free to explore our other services or get in touch with us.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center text-white/70 text-sm">
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-gold" />
                <span>+91 99873 43532</span>
              </div>
              <div className="hidden sm:block text-white/40">|</div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-gold" />
                <span>info@immaculate.ltd</span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/">
              <Button className="bg-gold hover:bg-gold/90 text-white font-semibold px-8 py-3 w-full sm:w-auto flex items-center justify-center gap-2 shadow-lg">
                <ArrowLeft className="w-4 h-4 text-white" />
                Back to Home
              </Button>
            </a>
            <a href="/contact">
              <Button 
                variant="outline" 
                className="border-2 border-white text-white hover:bg-white hover:text-brand-navy hover:border-white px-8 py-3 w-full sm:w-auto backdrop-blur-sm shadow-lg transition-all"
              >
                Contact Us
              </Button>
            </a>
          </div>

          {/* Progress Indicator */}
          <div className="mt-12 pt-8 border-t border-white/20">
            <p className="text-white/60 text-sm">
              We appreciate your patience as we build something exceptional
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoonPage;

